<router-outlet></router-outlet>
<rde-new-seo-component></rde-new-seo-component>
